<template>
  <div class="header-bar w-100" :class="bgColor">
    <div class="row w-100">
      <div class="col col-md-4">
        <h5>{{ heading }}</h5>
      </div>
      <div class="col d-sm-down-none" v-if="buttons.length">
          <span class="float-right mr-2" v-for="(button, index) in buttons" :key="'top-bar-button-' + index">
            <template v-if="button.access === undefined || button.access === true">
              <b-button :variant="button.variant || 'primary'" :to="button.url" v-if="button.url">{{ button.label }}</b-button>
              <b-button :variant="button.variant || 'primary'" @click="button.click" v-if="button.click">{{ button.label }}</b-button>
            </template>
          </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    heading: {
      type: String,
      required: true
    },
    buttons: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    bgColor: {
      type: String,
      default: 'bg-orange'
    }
  }
};
</script>

<style lang="scss">
  .header-bar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0.75rem 1rem;
    list-style: none;
    color: white;
    -webkit-transition: left 0.25s, right 0.25s, width 0.25s;
    transition: left 0.25s, right 0.25s, width 0.25s;
  }

</style>